export { default } from './MyBorrowingSidebar';



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/MyBorrowingSidebar/index.js